import React from "react";

const categories = [
  {
    icon: "👩‍🎓",
    title: "Apprenants & Parents",
    desc: "Inscription, suivi d’atelier, ressources pédagogiques…",
  },
  {
    icon: "🧑‍🏫",
    title: "Tuteurs & Mentors",
    desc: "Devenir tuteur, outils pédagogiques, animation de sessions…",
  },
  {
    icon: "🤝",
    title: "Partenaires & Fablabs",
    desc: "Collaborer avec GoNextMaker, accueillir des ateliers…",
  },
  {
    icon: "⚙️",
    title: "Compte & Paiement",
    desc: "Gestion du profil, moyens de paiement, facturation…",
  },
  {
    icon: "🔐",
    title: "Confidentialité & Sécurité",
    desc: "Protection des données, cookies, vie privée…",
  },
];

const HelpCategories = () => (
  <section className="w-full bg-light-5 py-12 px-6">
    <div className="max-w-6xl mx-auto">
      <h3 className="text-title font-bold text-dark-1 text-center mb-10">
        Catégories principales
      </h3>
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c, i) => (
          <div
            key={i}
            className="p-6 rounded-2xl text-center"
          >
            <div className="text-4xl mb-3">{c.icon}</div>
            <h4 className="font-semibold text-dark-1">{c.title}</h4>
            <p className="text-light-1 text-sm mt-2">{c.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HelpCategories;
